<template>
  <div class="main">
    <div class="main_bg">
      <div class="banner">
        <img :src="imageurl" style="width: 100%" />
        <div style="margin-top: -58px;">
          <contentMenu :index="2"></contentMenu>
        </div>
      </div>
      <div class="main2-content">
        <div class="img">
          <img src="../../assets/meb/imgs/gcgs/gcgsTop@2x.png" style="width: 100%" />
        </div>
        <div class="layout-flex">
          <div class="contentVideo">
            <img
              v-show="isImgShow"
              class="image"
              :src="videoimg"
              style="width: 100%"
              @click="handlePlay"
            />
            <video
              ref="video"
              class="video"
              @ended="handleEnd"
              preload
              controlslist="nodownload"
              :disablePictureInPicture="true"
            >
              <source :src="videourl" type="video/mp4" />
            </video>
          </div>
        </div>
        <contentRight :list="list[0]" :isTitleShow="false"></contentRight>
        <contentLeft :list="list[1]" :isTitleShow="false"></contentLeft>
        <contentRight :list="list[2]" :isTitleShow="false"></contentRight>
        <div style="height: 100px;background: #ffffff;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { csvw_url } from "../../components/config";
import config from "./config";
import contentMenu from "./contentMenu.vue";
import contentLeft from "./contentLeft.vue";
import contentRight from "./contentRight.vue";
import contentRight2 from "./contentRight2.vue";
export default {
  components: {
    contentMenu,
    contentLeft,
    contentRight,
    contentRight2
  },
  data() {
    return {
      imageurl: require("../../assets/meb/imgs/gcgs/home1@2x.png"),
      videourl: csvw_url + "/u/cms/www/202010/261834124oGl.mp4",
      videoimg: require("../../assets/meb/imgs/gcgs/home2@2x.png"),
      isImgShow: true,
      list: [
        {
          imageurl: require("../../assets/meb/imgs/gcgs/homeTu1@2x.png"),
          dec:
            "新工厂于2018年10月破土动工。2019年5月，各厂房主体结构封顶，设备开始安装调试。2019年10月开始预批量试生产。2019年11月，MEB工厂实现首台全工艺样车下线。首款下线产品是一款MEB平台纯电动中型SUV，也是上汽大众未来投产的首款ID.家族车型。",
          imgs: []
        },
        {
          imageurl: require("../../assets/meb/imgs/gcgs/homeTu2@2x.png"),
          dec:
            "MEB工厂通过数字化赋能，将“未来汽车的生产方式”进行了全面革新。新能源汽车工厂在自动化生产基础上，充分结合物联网、工业云等互联技术，对制造过程中的“大数据”进行精确采集、实时共享，打通信息流，实现从设计、生产到销售各环节互联互通，构建全业务链的智慧管理平台。",
          imgs: []
        },
        {
          imageurl: require("../../assets/meb/imgs/gcgs/homeTu3@2x.png"),
          dec:
            "未来，MEB工厂也将作为上汽大众的创新孵化基地，加速前瞻研究和智能技术的落地。上汽大众还将发挥自身产业链的优势，以整车智能制造为牵引，带动零部件企业同步提升智能制造能级，使汽车产业成为智能化转型升级的标杆行业。",
          imgs: []
        }
      ]
    };
  },
  mounted() {},
  methods: {
    handlePlay() {
      this.isImgShow = false;
      this.$refs.video.play();
    },
    handleEnd() {
      this.isImgShow = true;
      this.$refs.video.currentTime = 0;
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  min-width: 1200px;
  margin: 0px auto;
  font-size: 14px;
}

.main_bg {
  width: 100%;
  min-width: 1200px;
  background: #ffffff;
}

.main2-content {
  width: calc(100% - 60px);
  margin: 0px 30px;
}
.divHeight {
  height: 23px;
}

.main2-content {
  .layout-flex {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    padding: 60px;
    box-sizing: border-box;
  }
  .contentVideo {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .image {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
  }
  .video {
    width: 100%;
  }

  .img {
    width: 1200px;
    padding: 49px 60px 49px 68px;
    box-sizing: border-box;
    display: flex;
    margin-left: auto;
    margin-right: auto;
  }
}

@media screen and (min-width: 1600px) {
  .main2-content {
    .layout-flex {
      width: 1600px;
    }
    .img {
      width: 1600px;
    }
  }
}
</style>
